import { CheckIcon, LockIcon } from "lucide-react";
import React, { forwardRef } from "react";

import { classed } from "@/components/classed.config";
import { ButtonCard } from "@/components/elements/ButtonCard";
import classNames from "@/helpers/classNames";

export const ConnectorCard = forwardRef<
  HTMLButtonElement,
  {
    isLocked?: boolean;
    instanceCount?: number;
    icon: React.ReactNode;
  } & React.ComponentProps<typeof ButtonCard>
>((props, ref) => {
  const { className, children, isLocked, instanceCount, ...buttonProps } =
    props;
  return (
    <ButtonCard
      ref={ref}
      {...buttonProps}
      className={classNames(
        "group relative w-full items-center justify-start gap-4 rounded-xs p-4 text-left",
        className,
      )}
    >
      <div className="flex size-9 items-center justify-center">
        {props.icon}
      </div>
      {instanceCount !== undefined && instanceCount > 0 && (
        <div className="absolute right-0 bottom-0 m-2 h-3.5">
          <div className="inline-flex items-center text-1xs leading-none font-medium">
            <CheckIcon className="mr-1 size-3 text-green-500" />
            {instanceCount === 1 ? "Connected" : `${instanceCount} connections`}
          </div>
        </div>
      )}
      {isLocked && (
        <div className="absolute right-0 bottom-0 m-2">
          <div className="flex size-5 items-center justify-center rounded-full bg-gray-600/50 text-white dark:bg-gray-600/60">
            <LockIcon className="size-3" />
          </div>
        </div>
      )}
      {children}
    </ButtonCard>
  );
});

export const ConnectorCardContent = classed.div("flex min-w-0 flex-col gap-1");
export const ConnectorCardTitle = classed.div(
  "truncate text-sm font-medium leading-4 dark:text-white",
);
export const ConnectorCardLabels = classed.div(
  "flex flex-wrap items-center gap-1",
);
